import { uniqBy, sortBy, map, filter, find, concat } from 'lodash';

export default class SuggestionService {
    /* @ngInject */
    constructor() {
        this.reset();
    }

    reset() {
        this.terms = {};
    }

    initialize(teamId, terms) {
        this.terms[teamId] = this.filterTerms(terms || []);
    }

    add(teamId, term) {
        this.terms[teamId] = this.filterTerms(concat(this.terms[teamId] || [], [term]));
    }

    filterTerms(terms) {
        return uniqBy(sortBy(
            map(
                filter(terms || [], (term) => term && term.length > 0),
                (term) => term.trim()
            ),
            (term) => term.toLowerCase()
        ));
    }

    get(teamId, term) {
        return term && term.length > 0
            ? find(this.terms[teamId] || [], (note) => note && note.toLowerCase().indexOf(term.toLowerCase()) === 0)
            : null;
    }

    getMissingPart(teamId, term) {
        let note = this.get(teamId, term);
        return note ? note.substr(term.length, note.length - term.length) : null;
    }
}



// WEBPACK FOOTER //
// ./src/application/service/calendar/suggestion.service.js